// Calculator selction (home) labels keys
import { ImgNR1, ImgNR2, ImgCR, ImgCRNBR1, ImgNBR1, ImgNBR2, ImgNBR3, ImgNBR4, ImgNBR5, ImgCRM, ImgIIR1, ImgIIR2 } from '../components/dashboard/pages/glovesSelector/glovesSelection';
export const LABELKEYS_DASHBOARD = {
    HEADING: "DASHBOARD.MAIN_HEADING"
};
//API Paths
export const API_PATHS = {
    CONFIGURATIONS: "configurations",
    LABEL_CONFIG_LABELS: "labels"
};
//Store action type 
export const STORE_ACTION_TYPES = {
    APP_LANGUAGE_CHANGE: "appLanguageChange",
    USER_SELECTED_CHEMICALS: "userSelectedChemicals",
    USER_SELECTED_CHEMICALS_ARRAY: "userSelectedArrayChemicals",
    PRODUCT_STYLE_NUMBERS_ARRAY: "styleNumbersArray",
    GLOVE_RESULTS: "gloveResults",
    RESET_CALCULATOR: "calculator",
    CALCULATOR: "calculator",
    LANGUAGE_CHANGE_IND_HF: "languageChangeIndHF",
    INIT: "init",
    CONFIG_QUERY: "getConfigApi/executeQuery/fulfilled",
    PERMEATIONS_QUERY: "getPermeationsApi/executeQuery/fulfilled",
    FACET_QUERY: "facetApi/executeQuery/fulfilled",
    ERROR: "error",
    RESET_QUERY: "resetQuery",
    SET_FILTER_FACETS: "setFilterFacets",
    SET_KEY_STATUS:"setAppKeyStatus"
};
//Error Messages
export const ERROR_MESSAGES = {
    CONFIG_NOT_FOUND: "Error: Cannot access configuration files for this app",
    LANG_FILE_NOT_FOUND: "Error: Cannot access language files for this app",
    ERROR_HANDLING_MESSAGE: "ERROR_HANDLING.ERROR_HANDLING_MESSAGE",
    ERROR_HANDLING_SUB_HEADLINE: "ERROR_HANDLING.ERROR_HANDLING_SUB_HEADLINE",
    ERROR_HANDLING_HEADLINE: "ERROR_HANDLING.ERROR_HANDLING_HEADLINE"
};
//Error Messages
export const ERROR_HANDLER_LABELS_WARNINGS = {
    TITLE: "ERROR_HANDLER_LABELS_WARNINGS.TITLE",
    MESSAGE: "ERROR_HANDLER_LABELS_WARNINGS.MESSAGE",
    RESTART: "ERROR_HANDLER_LABELS_WARNINGS.RESTART",
    BACK: "ERROR_HANDLER_LABELS_WARNINGS.BACK"
};
//Error Warning Labels
export const CHEMICAL_SEARCH_WARNING_LABELS = {
    TITLE: "Glove Selector",
    MESSAGE: "Please Verify Chemicals Selected.The Selected Chemicals cannot be more than 25",
    BACK: "OK"
};
//Error Warning Labels
export const FACETS_LABELS = {
    PROTECTION_TYPE: "Protection Type",
    SIZE: "Size",
    THICKNESS: "Thickness (mm)",
    COLOR: "Color",
    LENGTH: "Length",
    GAUGE: "Gauge",
    ENISO: "EN ISO 374:2016",
    SPECIFICATIONS: "Specifications",
    MATERIAL: "Material",
    PESTICIDES: "Pesticides ISO 18889",
    COATING_TYPE: "Coating Type",
    GRIP: "Grip",
    CLEAR: "Clear"
};
//Error Messages
export const LABEL_KEYS_LOADER = {
    LOADING: "LABEL_KEYS_LOADER.LOADING",
    SAVING: "LABEL_KEYS_LOADER.SAVING",
    CALCULATING: "LABEL_KEYS_LOADER.CALCULATING",
    DOWNLOADING: "LABEL_KEYS_LOADER.DOWNLOADING"
};

//HOME
export const LABELKEYS_HOME =
{
    HEADING: "HOME.HEADING"
};
//ProgressBar Mobile
export const PROGRESS_BAR = {
    SHOW: "PROGRESSBAR.SHOW",
    OF: "PROGRESSBAR.OF"
};

//ARIA-LABLES
export const ARIA_LABEL = {
    LINK: "ARIA_LABELS.LINK"
};

export const LABELKEYS_WARNING = {
    START: "LABELKEY_WARNING.START",
    TEXT: "LABELKEY_WARNING.TEXT",
    NEW: "LABELKEY_WARNING.NEW",
    CONTINUE: "LABELKEY_WARNING.CONTINUE"
};
export const ERROR_WARNINGS = {
    RESTART: "ERROR_WARNINGS.RESTART",
    BACK: "ERROR_WARNINGS.BACK",
    ERROR: "ERROR_WARNINGS.ERROR"
};

export const REGEX_ITEMS =
{
    NUMBER: /^[0-9\b]+$/,
    FLOAT_NUMBER: /^([0-9]{1,})?(\.)?([0-9]{1,})?$/,
    SPACES:/ /g
};

// Calculation Types 
export const CALCULATION_TYPES = {
    SAVE_RESULTS: "Results",
    SAVE_SENSITIVITY: "Sensitivity Analysis"
};
// PDF Labels
export const LABELKEYS_PDF = {
    HEADLINE_SAVE_RESULTS_PDF: "LABELS_PDF.HEADLINE_SAVE_RESULTS_PDF",
    HEADLINE_SAVE_SENSITIVITY_PDF: "LABELS_PDF.HEADLINE_SAVE_SENSITIVITY_PDF",
    EMAIL: "LABELS_PDF.EMAIL",
    TECHNICAL_SUPPORT: "LABELS_PDF.TECHNICAL_SUPPORT",
    WEB_URL: "LABELS_PDF.WEB_URL"
};
// get timezone abbr
export const tzAbbr = (dateInput) => {
    const dateObject = dateInput ? new Date(dateInput) : new Date();
    const dateString = dateObject + "";
    let tzAbbrValue: any = (
        // Works for the majority of modern browsers
        dateString.match(/\(([^\)]+)\)$/) ||
        // IE outputs date strings in a different format:
        dateString.match(/([A-Z]+) [\d]{4}$/)
    );
    if (tzAbbrValue) {
        tzAbbrValue = tzAbbrValue[1].match(/[A-Z]/g).join("");
    }
    return tzAbbrValue;
};
export const REGEX_VALIDATION = {
    API_INPUT_FIELD_VALIDATION: /[!@#%&*~`^$_+\=\[\]{};':"\\|.<>\/?)(]+/gi,
    API_INPUT_FIELD_VALIDATION_DASH: /[-]+/gi,
    ELECTRICITY_PRICE_INPUT_FIELD_VALIDATION: /[a-zA-Z!@#%&*~`^$_+\=\[\]{-};':"\\|,()<>\/?]+/gi,
    VALID_EMAIL_EXPRESSION : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@honeywell+(?:\.[a-zA-Z0-9-]+)*$/,
    VALID_HID_EXPRESSION : /^[h,H,e,E][0-9]{6}$/
  
};
//base query 
export const FACETS_CHEMICAL_BASE_QUERY = (additinalFilters, languageSelectedForFacets, styleNumbers) => {
    return (
        {
            "query": "",
            "result_fields": {
                "style_no": {
                    "raw": {}
                },
                "pdf_url": {
                    "raw": {}
                }
            },
            "filters": {
                "all": [
                    {
                        "document_type": "Gloves"
                    },
                    {
                        "language": languageSelectedForFacets      
                    },
                    {
                        "style_no": styleNumbers
                    }, ...additinalFilters
                ]
            },
            "facets": {
                "aql_penetration_resistance": {
                    "type": "value",
                    "size": 250
                },
                "abrasion_resistance": {
                    "type": "value",
                    "size": 250
                },
                "antistatics_en_16350": {
                    "type": "value",
                    "size": 250
                },
                "clean_room_capability": {
                    "type": "value",
                    "size": 250
                },
                "coating_material": {
                    "type": "value",
                    "size": 250
                },
                "color": {
                    "type": "value",
                    "size": 250
                },
                "contact_cold": {
                    "type": "value",
                    "size": 250
                },
                "contact_heat": {
                    "type": "value",
                    "size": 250
                },
                "convective_cold": {
                    "type": "value",
                    "size": 250
                },
                "convective_heat": {
                    "type": "value",
                    "size": 250
                },
                "cut_protection_level": {
                    "type": "value",
                    "size": 250
                },
                "medical_devices": {
                    "type": "value",
                    "size": 250
                },
                "food_certifications": {
                    "type": "value",
                    "size": 250
                },
                "thickness": {
                    "type": "value",
                    "size": 250
                },
                "grip": {
                    "type": "value",
                    "size": 250
                },
                "cut_resistance_iso_13997_ansi_isea": {
                    "type": "value",
                    "size": 250
                },
                "impact_protection": {
                    "type": "value",
                    "size": 250
                },
                "molten_metal_large_quantities": {
                    "type": "value",
                    "size": 250
                },
                "latex_free": {
                    "type": "value",
                    "size": 250
                },
                "length": {
                    "type": "value",
                    "size": 250
                },
                "limited_flame_spread": {
                    "type": "value",
                    "size": 250
                },
                "lncludes_liner": {
                    "type": "value",
                    "size": 250
                },
                "lining_material": {
                    "type": "value",
                    "size": 250
                },
                "material": {
                    "type": "value",
                    "size": 250
                },
                "protection_type": {
                    "type": "value",
                    "size": 250
                },
                "microorganism_protection": {
                    "type": "value",
                    "size": 250
                },
                "tested_for_421": {
                    "type": "value",
                    "size": 250
                },
                "puncture_resistance": {
                    "type": "value",
                    "size": 250
                },
                "radiant_heat": {
                    "type": "value",
                    "size": 250
                },
                "silicon_free": {
                    "type": "value",
                    "size": 250
                },
                "size": {
                    "type": "value",
                    "size": 250
                },
                "molten_metal_small_splashes": {
                    "type": "value",
                    "size": 250
                },
                "tear_resistance": {
                    "type": "value",
                    "size": 250
                },
                "test_chemicals": {
                    "type": "value",
                    "size": 250
                },
                "touch_screen_capacitive": {
                    "type": "value",
                    "size": 250
                },
                "type": {
                    "type": "value",
                    "size": 250
                },
                "velourised": {
                    "type": "value",
                    "size": 250
                },
                "virus_protection": {
                    "type": "value",
                    "size": 250
                },
                "water_penetration": {
                    "type": "value",
                    "size": 250
                }
            },
            "page": {
                "current": 1,
                "size": 1000
            }
        }
    );

};
export const FACETS_GLOVE_BASE_QUERY = (searchQuery, additinalFilters, languageSelectedForFacets) => {
    return (
        {
            "query" : searchQuery || "" ,
            "filters": {
                "all": [
                    {
                        "document_type": "Gloves"
                    },
                    {
                        "language": languageSelectedForFacets       
                    }, ...additinalFilters
                ]
            },
            "sort": [
                {
                    "style_no": "asc"
                }
            ],
            "facets": {
                "aql_penetration_resistance": {
                    "type": "value",
                    "size": 250
                },
                "abrasion_resistance": {
                    "type": "value",
                    "size": 250
                },
                "antistatics_en_16350": {
                    "type": "value",
                    "size": 250
                },
                "brand": {
                    "type": "value",
                    "size": 250
                },
                "clean_room_capability": {
                    "type": "value",
                    "size": 250
                },
                "coating_type": {
                    "type": "value",
                    "size": 250
                },
                "coating_material": {
                    "type": "value",
                    "size": 250
                },
                "color": {
                    "type": "value",
                    "size": 250
                },
                "contact_cold": {
                    "type": "value",
                    "size": 250
                },
                "contact_heat": {
                    "type": "value",
                    "size": 250
                },
                "convective_cold": {
                    "type": "value",
                    "size": 250
                },
                "convective_heat": {
                    "type": "value",
                    "size": 250
                },
                "cut_protection_level": {
                    "type": "value",
                    "size": 250
                },
                "medical_devices": {
                    "type": "value",
                    "size": 250
                },
                "food_certifications": {
                    "type": "value",
                    "size": 250
                },
                "gauge": {
                    "type": "value",
                    "size": 250
                },
                "thickness": {
                    "type": "value",
                    "size": 250
                },
                "grip": {
                    "type": "value",
                    "size": 250
                },
                "cut_resistance_iso_13997_ansi_isea": {
                    "type": "value",
                    "size": 250
                },
                "impact_protection": {
                    "type": "value",
                    "size": 250
                },
                "molten_metal_large_quantities": {
                    "type": "value",
                    "size": 250
                },
                "latex_free": {
                    "type": "value",
                    "size": 250
                },
                "length": {
                    "type": "value",
                    "size": 250
                },
                "limited_flame_spread": {
                    "type": "value",
                    "size": 250
                },
                "lncludes_liner": {
                    "type": "value",
                    "size": 250
                },
                "lining_material": {
                    "type": "value",
                    "size": 250
                },
                "material": {
                    "type": "value",
                    "size": 250
                },
                "oeko_tex_100_class": {
                    "type": "value",
                    "size": 250
                },
                "protection_type": {
                    "type": "value",
                    "size": 250
                },
                "microorganism_protection": {
                    "type": "value",
                    "size": 250
                },
                "tested_for_421": {
                    "type": "value",
                    "size": 250
                },
                "puncture_resistance": {
                    "type": "value",
                    "size": 250
                },
                "radiant_heat": {
                    "type": "value",
                    "size": 250
                },
                "silicon_free": {
                    "type": "value",
                    "size": 250
                },
                "size": {
                    "type": "value",
                    "size": 250
                },
                "molten_metal_small_splashes": {
                    "type": "value",
                    "size": 250
                },
                "tear_resistance": {
                    "type": "value",
                    "size": 250
                },
                "test_chemicals": {
                    "type": "value",
                    "size": 250
                },
                "touch_screen_capacitive": {
                    "type": "value",
                    "size": 250
                },
                "type_en_12477_welding": {
                    "type": "value",
                    "size": 250
                },
                "type": {
                    "type": "value",
                    "size": 250
                },
                "velourised": {
                    "type": "value",
                    "size": 250
                },
                "virus_protection": {
                    "type": "value",
                    "size": 250
                },
                "washable": {
                    "type": "value",
                    "size": 250
                },
                "available_on_chempro": {
                    "type": "value",
                    "size": 250
                },
                "water_penetration": {
                    "type": "value",
                    "size": 250
                }
            },
            "search_fields": {
                "product_name": {
                    "weight": 5
                },
                "style_no": {
                    "weight": 5
                }
            },
            "precision": 8,
            "page": {
                "current": 1,
                "size": 1000
            }

        }
    );

};

export const INFO_AREA_BASE_QUERY = (searchQuery, additinalFilters) => {
    return (
        {
            "query": "",
            "filters": {
                "all": [
                    {
                        "document_type": "Info Area Documents"
                    },
                    {
                        "language": "en-US"
                    }
                ]
            },
            "search_fields": {
                "title": {
                    "weight": 5
                }
            },
            "sort": [
                {
                    "title": "asc"
                }
            ],
            "page": {
                "current": 1,
                "size": 1000

            }
        }
    );

};
//Base page paths
export const BASE_PAGE_PATHS = {
    HOME: "/",
    ADMIN_DASHBOARD: "/admin-dashboard"
};
export const PERMEATIONS_REQ_QUERY = (selectedChemicals,languageSelectedForProducts,styleNumbers) => {
    return(
        {
            "chemicalIds": selectedChemicals,
            "searchQuery": {
                "query": "",
                "result_fields": {
                    "style_no": {
                        "raw": {}
                    },
                    "pdf_url": {
                        "raw": {}
                    }
                },
                "filters": {
                    "all": [
                        {
                            "document_type": "Gloves"
                        },
                        {
                            "language": languageSelectedForProducts       
                        },
                        {
                            "style_no": styleNumbers
                        }
                    ]
                },
                "facets": {
                    "aql_penetration_resistance": {
                        "type": "value",
                        "size": 250
                    },
                    "abrasion_resistance": {
                        "type": "value",
                        "size": 250
                    },
                    "antistatics_en_16350": {
                        "type": "value",
                        "size": 250
                    },
                    "clean_room_capability": {
                        "type": "value",
                        "size": 250
                    },
                    "coating_type": {
                        "type": "value",
                        "size": 250
                    },
                    "coating_material": {
                        "type": "value",
                        "size": 250
                    },
                    "color": {
                        "type": "value",
                        "size": 250
                    },
                    "contact_cold": {
                        "type": "value",
                        "size": 250
                    },
                    "contact_heat": {
                        "type": "value",
                        "size": 250
                    },
                    "convective_cold": {
                        "type": "value",
                        "size": 250
                    },
                    "convective_heat": {
                        "type": "value",
                        "size": 250
                    },
                    "cut_protection_level": {
                        "type": "value",
                        "size": 250
                    },
                    "medical_devices": {
                        "type": "value",
                        "size": 250
                    },
                    "food_certifications": {
                        "type": "value",
                        "size": 250
                    },
                    "gauge": {
                        "type": "value",
                        "size": 250
                    },
                    "thickness": {
                        "type": "value",
                        "size": 250
                    },
                    "grip": {
                        "type": "value",
                        "size": 250
                    },
                    "cut_resistance_iso_13997_ansi_isea": {
                        "type": "value",
                        "size": 250
                    },
                    "impact_protection": {
                        "type": "value",
                        "size": 250
                    },
                    "molten_metal_large_quantities": {
                        "type": "value",
                        "size": 250
                    },
                    "latex_free": {
                        "type": "value",
                        "size": 250
                    },
                    "length": {
                        "type": "value",
                        "size": 250
                    },
                    "limited_flame_spread": {
                        "type": "value",
                        "size": 250
                    },
                    "lncludes_liner": {
                        "type": "value",
                        "size": 250
                    },
                    "lining_material": {
                        "type": "value",
                        "size": 250
                    },
                    "material": {
                        "type": "value",
                        "size": 250
                    },
                    "oeko_tex_100_class": {
                        "type": "value",
                        "size": 250
                    },
                    "protection_type": {
                        "type": "value",
                        "size": 250
                    },
                    "microorganism_protection": {
                        "type": "value",
                        "size": 250
                    },
                    "tested_for_421": {
                        "type": "value",
                        "size": 250
                    },
                    "puncture_resistance": {
                        "type": "value",
                        "size": 250
                    },
                    "radiant_heat": {
                        "type": "value",
                        "size": 250
                    },
                    "silicon_free": {
                        "type": "value",
                        "size": 250
                    },
                    "size": {
                        "type": "value",
                        "size": 250
                    },
                    "molten_metal_small_splashes": {
                        "type": "value",
                        "size": 250
                    },
                    "tear_resistance": {
                        "type": "value",
                        "size": 250
                    },
                    "test_chemicals": {
                        "type": "value",
                        "size": 250
                    },
                    "touch_screen_capacitive": {
                        "type": "value",
                        "size": 250
                    },
                    "type_en_12477_welding": {
                        "type": "value",
                        "size": 250
                    },
                    "type": {
                        "type": "value",
                        "size": 250
                    },
                    "velourised": {
                        "type": "value",
                        "size": 250
                    },
                    "virus_protection": {
                        "type": "value",
                        "size": 250
                    },
                    "washable": {
                        "type": "value",
                        "size": 250
                    },
                    "water_penetration": {
                        "type": "value",
                        "size": 250
                    }
                },
                "page": {
                    "current": 1,
                    "size": 1000
                }
        }
    }

    );
   
    };
    export const CHEMICAL_RESULTS_TABLE_LABEL_HEAD =
    [
        {
            fieldKey: "",
            fieldClassName: ""
        },
        {
            fieldKey: "kclGloves.Natural_Latex",
            fieldClassName: "natural-latex"
        },
        {
            fieldKey: "kclGloves.Chloroprene",
            fieldClassName: "chloroprene"
        },
        {
            fieldKey: "kclGloves.Nitrile_Chloroprene",
            fieldClassName: "nitrile"
        },
        {
            fieldKey: "kclGloves.Nitrile",
            fieldClassName: "nitrile-mob"
        },
        {
            fieldKey: "kclGloves.Fluoro_Carbonrubber",
            fieldClassName: "fluoro"
        },
        {
            fieldKey: "kclGloves.Butyl",
            fieldClassName: ""
        },
    ];
    export const CHEMICAL_RESULTS_TABLE_HEAD =
    [
        {
            fieldKey: "NR",
            multipleColumns: false,
            fieldKeyArray: ["NR1", "NR2"],
            fieldClassName: "info",
            fieldClickValue: "styleNumbersClicked"
        },
        {
            fieldKey: "CR",
            multipleColumns: false,
            fieldKeyArray: ["CR"],
            fieldClassName: "info1",
            fieldClickValue: "styleNumbersClicked"
        },
        {
            fieldKey: "CR_NBR",
            multipleColumns: false,
            fieldKeyArray: ["CR_NBR"],
            fieldClassName: "info1",
            fieldClickValue: "styleNumbersClicked"
        },
        {
            fieldKey: "NBR",
            multipleColumns: true,
            fieldClassName: "info",
            fieldInnerClassName: "info1",
            fieldKeyArray: ["NBR1", "NBR2", "NBR3", "NBR5"],
            fieldClickValue: "styleNumbersClicked"
        },
        {
            fieldKey: "FKM",
            multipleColumns: false,
            fieldKeyArray: ["FKM"],
            fieldClassName: "info1",
            fieldClickValue: "styleNumbersClicked"
        },
        {
            fieldKey: "IIR",
            multipleColumns: false,
            fieldKeyArray: ["IIR1", "IIR2"],
            fieldClassName: "info",
            fieldClickValue: "styleNumbersClicked"
        }
    ];
    export const CHEMICAL_RESULTS_TABLE_IMAGE_HEAD =
    [
        {
            fieldKey: "NR",
            multipleColumns: false,
            fieldKeyArray: ["NR1", "NR2"],
            fieldImage: [ImgNR1, ImgNR2],
            tableHeadClassName: undefined,
            fieldClassName: "info",
            fieldColumnClassName: "columns-2"
        },
        {
            fieldKey: "CR",
            multipleColumns: false,
            fieldKeyArray: ["CR"],
            fieldImage: [ImgCRNBR1],
            tableHeadClassName: undefined,
            fieldClassName: undefined,
            fieldColumnClassName: undefined
        },
        {
            fieldKey: "CR_NBR",
            multipleColumns: false,
            fieldKeyArray: ["CR_NBR"],
            fieldImage: [ImgCR],
            tableHeadClassName: undefined,
            fieldClassName: undefined,
            fieldColumnClassName: undefined
        },
        {
            fieldKey: "NBR",
            multipleColumns: true,
            fieldKeyArray: ["NBR1", "NBR2", "NBR3", "NBR5"],
            fieldImage: [ImgNBR1, ImgNBR2, ImgNBR3, ImgNBR5],
            tableHeadClassName: "mobile-view",
            fieldClassName: "info",
            fieldColumnClassName: "columns-4"
        },
        {
            fieldKey: "FKM",
            multipleColumns: false,
            fieldKeyArray: ["FKM"],
            fieldImage: [ImgCRM],
            tableHeadClassName: undefined,
            fieldClassName: undefined,
            fieldColumnClassName: undefined
        },
        {
            fieldKey: "IIR",
            multipleColumns: false,
            fieldKeyArray: ["IIR1", "IIR2"],
            fieldImage: [ImgIIR1, ImgIIR2],
            tableHeadClassName: undefined,
            fieldClassName: "info",
            fieldColumnClassName: "columns-2"
        }
    ];
    export const CHEMICAL_RESULTS_TABLE_DATA =
    [
        {
            fieldKey: "NR",
            multipleColumns: false,
            fieldKeyArray: ["NR1", "NR2"],
            fieldClassName: "info",
            fieldColumnClassName: "columns-2",
        },
        {
            fieldKey: "CR",
            multipleColumns: false,
            fieldKeyArray: ["CR"],
            fieldClassName: undefined,
            fieldColumnClassName: undefined,
        },
        {
            fieldKey: "CR_NBR",
            multipleColumns: false,
            fieldKeyArray: ["CR_NBR"],
            fieldClassName: undefined,
            fieldColumnClassName: undefined,
        },
        {
            fieldKey: "NBR",
            multipleColumns: true,
            fieldClassName: "info",
            fieldKeyArray: ["NBR1", "NBR2", "NBR3", "NBR5"],
            fieldColumnClassName: "columns-4",
        },
        {
            fieldKey: "FKM",
            multipleColumns: false,
            fieldKeyArray: ["FKM"],
            fieldClassName: undefined,
            fieldColumnClassName: undefined,
        },
        {
            fieldKey: "IIR",
            multipleColumns: false,
            fieldKeyArray: ["IIR1", "IIR2"],
            fieldClassName: "info",
            fieldColumnClassName: "columns-2",
        }
    ];